import styled, { css } from 'styled-components';
import { nuDSColor, spacing } from '@nubank/nuds-web/styles/themeUtils';
import { breakpointsMedia } from '@nubank/nuds-web/styles/breakpoints';

export const PriceBoxContent = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 24rem;

  margin: ${spacing('8x')} 0;
`;

PriceBoxContent.displayName = 'PriceBoxContent';

export const PriceBox = styled.div`
  background-color: ${nuDSColor('white', 'dark')};
  border-radius: 2px;
  box-sizing: border-box;
  color: ${nuDSColor('black', 'default')};
  font-size: ${p => p.theme.fontSizes[2]}px;
  outline: none;
  text-align: center;
  width: calc(50% - 8px);
  padding: 22px 22px;

  ${breakpointsMedia({
    sm: css`
      padding: 22px 32px;
    `,
  })}
`;

PriceBox.displayName = 'PriceBox';
